export const FileType = {
    svg: "svg",
    dxf: "dxf",
    step: "step",
    png: "png",
    geo: "geo",
    [Symbol.iterator]: function () { return [this.svg, this.dxf, this.step, this.png, this.geo,][Symbol.iterator](); }
};
export const InputType = {
    undefined: "undefined",
    documentGraph: "documentGraph",
    assembly: "assembly",
    layered: "layered",
    twoDimRep: "twoDimRep",
    [Symbol.iterator]: function () { return [this.undefined, this.documentGraph, this.assembly, this.layered, this.twoDimRep,][Symbol.iterator](); }
};
export const DatabaseType = {
    mssql: "mssql",
    [Symbol.iterator]: function () { return [this.mssql,][Symbol.iterator](); }
};
export const FileSystemPathType = {
    directory: "directory",
    openFile: "openFile",
    saveFile: "saveFile",
    [Symbol.iterator]: function () { return [this.directory, this.openFile, this.saveFile,][Symbol.iterator](); }
};
export const WorkStepType = {
    undefined: "undefined",
    sheet: "sheet",
    sheetCutting: "sheetCutting",
    joining: "joining",
    tubeCutting: "tubeCutting",
    sheetBending: "sheetBending",
    userDefined: "userDefined",
    userDefinedBase: "userDefinedBase",
    packaging: "packaging",
    transform: "transform",
    tube: "tube",
    [Symbol.iterator]: function () { return [this.undefined, this.sheet, this.sheetCutting, this.joining, this.tubeCutting, this.sheetBending, this.userDefined, this.userDefinedBase, this.packaging, this.transform, this.tube,][Symbol.iterator](); }
};
export const BendDieChoiceType = {
    database: "database",
    neutralAxis: "neutralAxis",
    [Symbol.iterator]: function () { return [this.database, this.neutralAxis,][Symbol.iterator](); }
};
export const DocumentItemType = {
    paragraph: "paragraph",
    heading: "heading",
    table: "table",
    image: "image",
    barcode: "barcode",
    separator: "separator",
    pageBreak: "pageBreak",
    [Symbol.iterator]: function () { return [this.paragraph, this.heading, this.table, this.image, this.barcode, this.separator, this.pageBreak,][Symbol.iterator](); }
};
export const DocumentAlignment = {
    left: "left",
    center: "center",
    right: "right",
    [Symbol.iterator]: function () { return [this.left, this.center, this.right,][Symbol.iterator](); }
};
export const DocumentImageType = {
    png: "png",
    svg: "svg",
    [Symbol.iterator]: function () { return [this.png, this.svg,][Symbol.iterator](); }
};
export const DocumentOrientation = {
    portrait: "portrait",
    landscape: "landscape",
    [Symbol.iterator]: function () { return [this.portrait, this.landscape,][Symbol.iterator](); }
};
export const GraphNodeProcessingState = {
    CreateWorkStep: "CreateWorkStep",
    UpdateWorkStep: "UpdateWorkStep",
    CreateSources: "CreateSources",
    FillFromSources: "FillFromSources",
    AfterFillFromSources: "AfterFillFromSources",
    Finished: "Finished",
    [Symbol.iterator]: function () { return [this.CreateWorkStep, this.UpdateWorkStep, this.CreateSources, this.FillFromSources, this.AfterFillFromSources, this.Finished,][Symbol.iterator](); }
};
export const ProcessType = {
    undefined: "undefined",
    manufacturing: "manufacturing",
    semiManufactured: "semiManufactured",
    sheetCutting: "sheetCutting",
    laserSheetCutting: "laserSheetCutting",
    joining: "joining",
    externalPart: "externalPart",
    sheet: "sheet",
    userDefinedBaseType: "userDefinedBaseType",
    assembling: "assembling",
    forceFitting: "forceFitting",
    joiningByWelding: "joiningByWelding",
    joiningByBrazing: "joiningByBrazing",
    bonding: "bonding",
    autogenousWelding: "autogenousWelding",
    arcWelding: "arcWelding",
    gasShieldedWelding: "gasShieldedWelding",
    migWelding: "migWelding",
    magWelding: "magWelding",
    tigWelding: "tigWelding",
    plasmaWelding: "plasmaWelding",
    laserWelding: "laserWelding",
    weldingWithPressure: "weldingWithPressure",
    resistanceWelding: "resistanceWelding",
    studWelding: "studWelding",
    forming: "forming",
    bendForming: "bendForming",
    bendingWithoutTool: "bendingWithoutTool",
    dieBending: "dieBending",
    sheetMetalFolding: "sheetMetalFolding",
    cutting: "cutting",
    removalOperation: "removalOperation",
    plasmaSheetCutting: "plasmaSheetCutting",
    waterJetSheetCutting: "waterJetSheetCutting",
    machining: "machining",
    milling: "milling",
    turning: "turning",
    drilling: "drilling",
    threading: "threading",
    mechanicalDeburring: "mechanicalDeburring",
    cleaning: "cleaning",
    coating: "coating",
    sprayPainting: "sprayPainting",
    powderCoating: "powderCoating",
    sheetBending: "sheetBending",
    transport: "transport",
    packaging: "packaging",
    automaticMechanicalDeburring: "automaticMechanicalDeburring",
    manualMechanicalDeburring: "manualMechanicalDeburring",
    userDefinedMachining: "userDefinedMachining",
    userDefinedThreading: "userDefinedThreading",
    userDefinedCountersinking: "userDefinedCountersinking",
    slideGrinding: "slideGrinding",
    sheetTapping: "sheetTapping",
    userDefinedTube: "userDefinedTube",
    tube: "tube",
    tubeCutting: "tubeCutting",
    [Symbol.iterator]: function () { return [this.undefined, this.manufacturing, this.semiManufactured, this.sheetCutting, this.laserSheetCutting, this.joining, this.externalPart, this.sheet, this.userDefinedBaseType, this.assembling, this.forceFitting, this.joiningByWelding, this.joiningByBrazing, this.bonding, this.autogenousWelding, this.arcWelding, this.gasShieldedWelding, this.migWelding, this.magWelding, this.tigWelding, this.plasmaWelding, this.laserWelding, this.weldingWithPressure, this.resistanceWelding, this.studWelding, this.forming, this.bendForming, this.bendingWithoutTool, this.dieBending, this.sheetMetalFolding, this.cutting, this.removalOperation, this.plasmaSheetCutting, this.waterJetSheetCutting, this.machining, this.milling, this.turning, this.drilling, this.threading, this.mechanicalDeburring, this.cleaning, this.coating, this.sprayPainting, this.powderCoating, this.sheetBending, this.transport, this.packaging, this.automaticMechanicalDeburring, this.manualMechanicalDeburring, this.userDefinedMachining, this.userDefinedThreading, this.userDefinedCountersinking, this.slideGrinding, this.sheetTapping, this.userDefinedTube, this.tube, this.tubeCutting,][Symbol.iterator](); }
};
export const TubeProfileGeometryType = {
    rectangular: "rectangular",
    circular: "circular",
    [Symbol.iterator]: function () { return [this.rectangular, this.circular,][Symbol.iterator](); }
};
export const TableType = {
    sheetMaterial: "sheetMaterial",
    sheetMaterialDensity: "sheetMaterialDensity",
    sheetCuttingMaterialMapping: "sheetCuttingMaterialMapping",
    sheetBendingMaterialMapping: "sheetBendingMaterialMapping",
    bendTime: "bendTime",
    bendTimeParameters: "bendTimeParameters",
    bendRateParameters: "bendRateParameters",
    bendLineConstraint: "bendLineConstraint",
    laserSheetCuttingGas: "laserSheetCuttingGas",
    laserSheetCuttingSpeed: "laserSheetCuttingSpeed",
    laserSheetCuttingPierceTime: "laserSheetCuttingPierceTime",
    laserSheetCuttingRate: "laserSheetCuttingRate",
    laserSheetCuttingMinArea: "laserSheetCuttingMinArea",
    laserSheetCuttingMaxThickness: "laserSheetCuttingMaxThickness",
    packaging: "packaging",
    transportationCosts: "transportationCosts",
    surcharge: "surcharge",
    process: "process",
    processRate: "processRate",
    processSetupTimeFallback: "processSetupTimeFallback",
    processUnitTimeFallback: "processUnitTimeFallback",
    sheet: "sheet",
    sheetModulus: "sheetModulus",
    sheetPrice: "sheetPrice",
    upperDieGroup: "upperDieGroup",
    lowerDieGroup: "lowerDieGroup",
    bendDeduction: "bendDeduction",
    setting: "setting",
    automaticMechanicalDeburringMaterial: "automaticMechanicalDeburringMaterial",
    automaticMechanicalDeburringParameters: "automaticMechanicalDeburringParameters",
    dimensionConstraints: "dimensionConstraints",
    screwThread: "screwThread",
    tappingTimeParameters: "tappingTimeParameters",
    tubeMaterial: "tubeMaterial",
    tubeMaterialDensity: "tubeMaterialDensity",
    tubeProfile: "tubeProfile",
    tubeSpecification: "tubeSpecification",
    tube: "tube",
    upperDie: "upperDie",
    lowerDie: "lowerDie",
    upperDieUnit: "upperDieUnit",
    lowerDieUnit: "lowerDieUnit",
    processHandlingTime: "processHandlingTime",
    sheetStock: "sheetStock",
    processIdlePeriod: "processIdlePeriod",
    sheetMaterialScrapValue: "sheetMaterialScrapValue",
    sheetPriority: "sheetPriority",
    dieGroupPriority: "dieGroupPriority",
    sheetCuttingMaterial: "sheetCuttingMaterial",
    sheetBendingMaterial: "sheetBendingMaterial",
    tubeCuttingProcess: "tubeCuttingProcess",
    tubeCuttingProcessMapping: "tubeCuttingProcessMapping",
    tubeCuttingSpeed: "tubeCuttingSpeed",
    tubeCuttingPierceTime: "tubeCuttingPierceTime",
    tubePrice: "tubePrice",
    tubeStock: "tubeStock",
    tubeMaterialScrapValue: "tubeMaterialScrapValue",
    [Symbol.iterator]: function () { return [this.sheetMaterial, this.sheetMaterialDensity, this.sheetCuttingMaterialMapping, this.sheetBendingMaterialMapping, this.bendTime, this.bendTimeParameters, this.bendRateParameters, this.bendLineConstraint, this.laserSheetCuttingGas, this.laserSheetCuttingSpeed, this.laserSheetCuttingPierceTime, this.laserSheetCuttingRate, this.laserSheetCuttingMinArea, this.laserSheetCuttingMaxThickness, this.packaging, this.transportationCosts, this.surcharge, this.process, this.processRate, this.processSetupTimeFallback, this.processUnitTimeFallback, this.sheet, this.sheetModulus, this.sheetPrice, this.upperDieGroup, this.lowerDieGroup, this.bendDeduction, this.setting, this.automaticMechanicalDeburringMaterial, this.automaticMechanicalDeburringParameters, this.dimensionConstraints, this.screwThread, this.tappingTimeParameters, this.tubeMaterial, this.tubeMaterialDensity, this.tubeProfile, this.tubeSpecification, this.tube, this.upperDie, this.lowerDie, this.upperDieUnit, this.lowerDieUnit, this.processHandlingTime, this.sheetStock, this.processIdlePeriod, this.sheetMaterialScrapValue, this.sheetPriority, this.dieGroupPriority, this.sheetCuttingMaterial, this.sheetBendingMaterial, this.tubeCuttingProcess, this.tubeCuttingProcessMapping, this.tubeCuttingSpeed, this.tubeCuttingPierceTime, this.tubePrice, this.tubeStock, this.tubeMaterialScrapValue,][Symbol.iterator](); }
};
export const TableErrorType = {
    referringEntryMissing: "referringEntryMissing",
    referredEntryMissing: "referredEntryMissing",
    valueInvalid: "valueInvalid",
    uniqueMemberCollision: "uniqueMemberCollision",
    [Symbol.iterator]: function () { return [this.referringEntryMissing, this.referredEntryMissing, this.valueInvalid, this.uniqueMemberCollision,][Symbol.iterator](); }
};
export const Feature = {
    bendMeasurementScene: "bendMeasurementScene",
    bomExport: "bomExport",
    graphRepExport: "graphRepExport",
    unlimitedNumExports: "unlimitedNumExports",
    httpServiceUnfold: "httpServiceUnfold",
    httpServiceNestor: "httpServiceNestor",
    httpServiceAssemblyTree: "httpServiceAssemblyTree",
    lstExport: "lstExport",
    erpInterfaceItBlech: "erpInterfaceItBlech",
    tubeDetection: "tubeDetection",
    [Symbol.iterator]: function () { return [this.bendMeasurementScene, this.bomExport, this.graphRepExport, this.unlimitedNumExports, this.httpServiceUnfold, this.httpServiceNestor, this.httpServiceAssemblyTree, this.lstExport, this.erpInterfaceItBlech, this.tubeDetection,][Symbol.iterator](); }
};
export const ReplyStateIndicatorPackaging = {
    undefinedError: "undefinedError",
    insufficientPackageVolume: "insufficientPackageVolume",
    overweightParts: "overweightParts",
    [Symbol.iterator]: function () { return [this.undefinedError, this.insufficientPackageVolume, this.overweightParts,][Symbol.iterator](); }
};
export const ReplyStateIndicatorTransform = {
    undefinedError: "undefinedError",
    [Symbol.iterator]: function () { return [this.undefinedError,][Symbol.iterator](); }
};
export const ReplyStateIndicatoruserDefined = {
    undefinedError: "undefinedError",
    [Symbol.iterator]: function () { return [this.undefinedError,][Symbol.iterator](); }
};
export const ReplyStateIndicatoruserDefinedBase = {
    undefinedError: "undefinedError",
    [Symbol.iterator]: function () { return [this.undefinedError,][Symbol.iterator](); }
};
export const ReplyStateIndicatorUndefined = {
    undefinedError: "undefinedError",
    [Symbol.iterator]: function () { return [this.undefinedError,][Symbol.iterator](); }
};
export const ReplyStateIndicatorTubeCutting = {
    undefinedError: "undefinedError",
    undetectedFeatures: "undetectedFeatures",
    [Symbol.iterator]: function () { return [this.undefinedError, this.undetectedFeatures,][Symbol.iterator](); }
};
export const ReplyStateIndicatorJoining = {
    undefinedError: "undefinedError",
    [Symbol.iterator]: function () { return [this.undefinedError,][Symbol.iterator](); }
};
export const ReplyStateIndicatorSheet = {
    undefinedError: "undefinedError",
    nestingFailed: "nestingFailed",
    [Symbol.iterator]: function () { return [this.undefinedError, this.nestingFailed,][Symbol.iterator](); }
};
export const ReplyStateIndicatorSheetCutting = {
    undefinedError: "undefinedError",
    undetectedFeatures: "undetectedFeatures",
    multipleOuterContours: "multipleOuterContours",
    unused0: "unused0",
    [Symbol.iterator]: function () { return [this.undefinedError, this.undetectedFeatures, this.multipleOuterContours, this.unused0,][Symbol.iterator](); }
};
export const ReplyStateIndicatorSheetBending = {
    undefinedError: "undefinedError",
    multipleOuterContours: "multipleOuterContours",
    contourInBend: "contourInBend",
    invalidBend: "invalidBend",
    undetectedFeatures: "undetectedFeatures",
    [Symbol.iterator]: function () { return [this.undefinedError, this.multipleOuterContours, this.contourInBend, this.invalidBend, this.undetectedFeatures,][Symbol.iterator](); }
};
export const ReplyStateIndicatorTube = {
    undefinedError: "undefinedError",
    [Symbol.iterator]: function () { return [this.undefinedError,][Symbol.iterator](); }
};
export const FileDialogType = {
    openFile: "openFile",
    openFiles: "openFiles",
    saveFile: "saveFile",
    directory: "directory",
    [Symbol.iterator]: function () { return [this.openFile, this.openFiles, this.saveFile, this.directory,][Symbol.iterator](); }
};
export const FormWidgetType = {
    checkBox: "checkBox",
    spinBox: "spinBox",
    dropDown: "dropDown",
    lineEdit: "lineEdit",
    textEdit: "textEdit",
    label: "label",
    [Symbol.iterator]: function () { return [this.checkBox, this.spinBox, this.dropDown, this.lineEdit, this.textEdit, this.label,][Symbol.iterator](); }
};
export const MessageBoxType = {
    info: "info",
    warning: "warning",
    error: "error",
    question: "question",
    [Symbol.iterator]: function () { return [this.info, this.warning, this.error, this.question,][Symbol.iterator](); }
};
export const GeometrySelectorConfigFlag = {
    edge: "edge",
    face: "face",
    [Symbol.iterator]: function () { return [this.edge, this.face,][Symbol.iterator](); }
};
export const WidgetType = {
    assemblyView: "assemblyView",
    attachmentEditor: "attachmentEditor",
    bendingToolEditor: "bendingToolEditor",
    calcParamEditor: "calcParamEditor",
    fileDialog: "fileDialog",
    formEditor: "formEditor",
    geometrySelector: "geometrySelector",
    geometryColorSelector: "geometryColorSelector",
    joiningSequenceEditor: "joiningSequenceEditor",
    layeredImportDialog: "layeredImportDialog",
    messageBox: "messageBox",
    processSelector: "processSelector",
    sheetFilterEditor: "sheetFilterEditor",
    sheetTappingEditor: "sheetTappingEditor",
    [Symbol.iterator]: function () { return [this.assemblyView, this.attachmentEditor, this.bendingToolEditor, this.calcParamEditor, this.fileDialog, this.formEditor, this.geometrySelector, this.geometryColorSelector, this.joiningSequenceEditor, this.layeredImportDialog, this.messageBox, this.processSelector, this.sheetFilterEditor, this.sheetTappingEditor,][Symbol.iterator](); }
};
export const SegmentType = {
    line: "line",
    arc: "arc",
    [Symbol.iterator]: function () { return [this.line, this.arc,][Symbol.iterator](); }
};
export const GeometryEntityType = {
    edge: "edge",
    face: "face",
    [Symbol.iterator]: function () { return [this.edge, this.face,][Symbol.iterator](); }
};
export const CamCommandType = {
    setColor: "setColor",
    [Symbol.iterator]: function () { return [this.setColor,][Symbol.iterator](); }
};
export const Color = {
    black: "black",
    white: "white",
    green: "green",
    yellow: "yellow",
    cyan: "cyan",
    blue: "blue",
    magenta: "magenta",
    none: "none",
    red: "red",
    lightgrey: "lightgrey",
    lime: "lime",
    turquoise: "turquoise",
    violet: "violet",
    saddlebrown: "saddlebrown",
    darkorange: "darkorange",
    sienna: "sienna",
    closedContour: "closedContour",
    closedInnerContour: "closedInnerContour",
    closedOuterContour: "closedOuterContour",
    openContour: "openContour",
    engraving: "engraving",
    bendLine: "bendLine",
    bendLineUp: "bendLineUp",
    bendLineDown: "bendLineDown",
    [Symbol.iterator]: function () { return [this.black, this.white, this.green, this.yellow, this.cyan, this.blue, this.magenta, this.none, this.red, this.lightgrey, this.lime, this.turquoise, this.violet, this.saddlebrown, this.darkorange, this.sienna, this.closedContour, this.closedInnerContour, this.closedOuterContour, this.openContour, this.engraving, this.bendLine, this.bendLineUp, this.bendLineDown,][Symbol.iterator](); }
};
export const StrokeStyle = {
    continuous: "continuous",
    dashed: "dashed",
    [Symbol.iterator]: function () { return [this.continuous, this.dashed,][Symbol.iterator](); }
};
export const PrivateGuiDataType = {
    graphRep: "graphRep",
    [Symbol.iterator]: function () { return [this.graphRep,][Symbol.iterator](); }
};
export const TwoDimImportResultType = {
    partInvalid: "partInvalid",
    engravingInvalid: "engravingInvalid",
    success: "success",
    [Symbol.iterator]: function () { return [this.partInvalid, this.engravingInvalid, this.success,][Symbol.iterator](); }
};
export const DatabasePermission = {
    read: "read",
    write: "write",
    [Symbol.iterator]: function () { return [this.read, this.write,][Symbol.iterator](); }
};
export const LocaleType = {
    language: "language",
    csv: "csv",
    [Symbol.iterator]: function () { return [this.language, this.csv,][Symbol.iterator](); }
};
export const AddResultStatus = {
    success: "success",
    unsupportedFormat: "unsupportedFormat",
    versionMismatch: "versionMismatch",
    inconsistentGraph: "inconsistentGraph",
    undefinedError: "undefinedError",
    unsupportedVersion: "unsupportedVersion",
    [Symbol.iterator]: function () { return [this.success, this.unsupportedFormat, this.versionMismatch, this.inconsistentGraph, this.undefinedError, this.unsupportedVersion,][Symbol.iterator](); }
};
export const TrumpfLoadingSystem = {
    manual: "manual",
    paletteChange: "paletteChange",
    paletteChangeLiftMaster: "paletteChangeLiftMaster",
    onePalette: "onePalette",
    paletteChangeLiftMasterSort: "paletteChangeLiftMasterSort",
    paletteChangeLiftMasterSortPullingDevice: "paletteChangeLiftMasterSortPullingDevice",
    [Symbol.iterator]: function () { return [this.manual, this.paletteChange, this.paletteChangeLiftMaster, this.onePalette, this.paletteChangeLiftMasterSort, this.paletteChangeLiftMasterSortPullingDevice,][Symbol.iterator](); }
};
export const LstEvaporateMode = {
    none: "none",
    early: "early",
    beforeEachPart: "beforeEachPart",
    [Symbol.iterator]: function () { return [this.none, this.early, this.beforeEachPart,][Symbol.iterator](); }
};
export const SheetCorner = {
    lowerLeft: "lowerLeft",
    upperLeft: "upperLeft",
    lowerRight: "lowerRight",
    upperRight: "upperRight",
    [Symbol.iterator]: function () { return [this.lowerLeft, this.upperLeft, this.lowerRight, this.upperRight,][Symbol.iterator](); }
};
